import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import * as signupActions from '@modules/login/actions/signup.actions';
import * as loginReducers from '@modules/login/reducers';
import { select, Store } from '@ngrx/store';
import { log } from 'console';
import { CustomValidators } from 'ng2-validation';

export interface CompanyType {
    value: string;
    viewValue: string;
}

@Component({
    selector: 'edex-register-merchant',
    templateUrl: './register-merchant.component.html',
    styleUrls: ['./register-merchant.component.scss']
})
export class RegisterMerchantComponent implements OnInit {
    hide :boolean = false;
    showDrop:boolean = false;
    registerAs:any[]=[];
    registerAsForm:any;

    public signupFormGroup: FormGroup;
    public userSignupPassword = new FormControl('', [
        Validators.required,
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')
    ]);
    public signupPasswordConfirm = new FormControl('', CustomValidators.equalTo(this.userSignupPassword));

    public signupSubmitted = false;
    disbaledResetButton = false;
    timer: number = 0;
   intervalRef: any = null;


    public signupPending$ = this.store.pipe(select(loginReducers.getSignupPending));
    public signupSuccess$ = this.store.pipe(select(loginReducers.getSignupSuccess));
    public signupError$ = this.store.pipe(select(loginReducers.getSignupError));
    public signupUser$ = this.store.pipe(select(loginReducers.getSignupUser));
    error: boolean=false;

    constructor(
        private store: Store<loginReducers.State>,
        private fb: FormBuilder,
         private _snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.signupFormGroup = this.fb.group({
            signupContactName: [''],
            signupCompanyName: [''],
            signupPhoneNumberSMS: [''],
            signupPhoneNumberCall: [''],
            // offerCode: [''],
            einNumber: [''],
            signupEmail: ['', [Validators.required, CustomValidators.email]],
            signupPassword: this.userSignupPassword,
            signupContactPermission: ['', []],
            salesAgent:[false],
            SAmerchantReferenceNumber:[''],
        });


        this.registerAs = [{name:'Merchant',value:'0'},{name:'Merchant under a Sales Agent',value:'1'},{name:'Sales Agent',value:'2'}]
        this.signupFormGroup.valueChanges.subscribe(changes => {
            this.signupSubmitted = false;
        });
    }

    showRefInput(data) {
        if(data.value == '1') {
            this.error = false;
            this.showDrop = true;
            this.signupFormGroup.value.salesAgent = true;
        } else if(data.value == '2') {
            this.error = false;
            this.showDrop = false;
            this.signupFormGroup.value.salesAgent = true;
        }else {
            this.error = false;
            this.showDrop = false;
            this.signupFormGroup.value.salesAgent = false;
        }
    }

    checkError(controlName: string, errorName: string) {
        return this.signupFormGroup.controls[controlName].hasError(errorName);
     }

    submit() {
       if(!this.registerAsForm) {
            this.error = true;
            return
       }
      if(this.registerAsForm.value == '1' && !this.signupFormGroup.value.SAmerchantReferenceNumber) {
            this.error = true;
            return
       }
        this.signupSubmitted = true;
        window.console.log(this.signupFormGroup.value);
        if (this.signupFormGroup.valid && this.signupPasswordConfirm.valid && this.error == false) {
            this.store.dispatch(new signupActions.CreatePendingMerchant(this.signupFormGroup.value));
        }
    }

resendPendingMerchantLink() {
  try {
    // disable
    this.disbaledResetButton = true;
    this.timer = 10;  // 10 seconds countdown

    this.store.dispatch(new signupActions.ResendPendingMerchantLink(this.signupFormGroup.value.signupEmail));
    this._snackBar.open('Activation email resent successfully', '', { duration: 3000 });
    // start countdown
    this.intervalRef = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        this.disbaledResetButton = false;
        clearInterval(this.intervalRef);
      }
    }, 1000);
  } catch (error) {
    this._snackBar.open('Error resending activation email', '', { duration: 3000 });
  }
}


    controlInvalid(formGroup: FormGroup, controlName: string, submitted: boolean) {
        return (formGroup.controls[controlName].invalid && submitted);
    }

    getErrorPassword() {
        return this.signupFormGroup.get('signupPassword').hasError('pattern')
          ? 'Password must contain 8 Characters: 1 Uppercase, 1 Lowercase, 1 Number and 1 Special Character'
          : this.signupFormGroup.get('signupPassword').hasError('required')
            ? 'Not a valid password'
            : '';
    }

    getErrorEmail() {
        return this.signupFormGroup.get('signupEmail').hasError('email') ? 'You must enter a valid email address' :
            this.signupFormGroup.get('signupEmail').hasError('required') ? 'Not a valid email' :
                '';
    }

    getSAmerchantReferenceNumber() {
        return this.signupFormGroup.get('SAmerchantReferenceNumber').hasError('required') ? 'Please enter Sales Agent Reference Number' :
            '';
    }
}
